import * as React from "react";

import { creators, MessageCheckerActionTypes } from ".";
import { getUserFromStorage, telemetryService } from "../../../modules";
import { messageService } from "../messaging.service";
import { useRelodeApp } from "../../../";

export const useMessageCheckerActions = (
    dispatch: React.Dispatch<MessageCheckerActionTypes>
) => {
    const {
        actions: relodeAppActions,
        state: { haltApiCalls, currentUser },
    } = useRelodeApp();
    const getUnread = async () => {
        if (haltApiCalls) return;
        dispatch(creators.getUnread());
        try {
            if (!currentUser) return;

            const count = await messageService.getUnreadCount();

            dispatch(creators.updateUnreadCount(count));
            relodeAppActions.apiCallSuccess();
        } catch (err) {
            relodeAppActions.apiCallFailure();
            telemetryService.trackEvent(
                "Error: messages.messageActions.getUnread",
                {
                    message: JSON.stringify(err),
                }
            );
        }
    };

    const updateUnreadCount = (count: number) => {
        dispatch(creators.updateUnreadCount(count));
    };

    return {
        getUnread,
        updateUnreadCount,
    };
};

export type MessageCheckerActions = ReturnType<typeof useMessageCheckerActions>;
